import { TableCell } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledTableCell = styled(TableCell)<{
  $isLeftOver: boolean;
  $isRightOver: boolean;
  $highlight: boolean;
  $width: number;
}>`
  background-color: ${props => props.$highlight && 'var(--text-inverse)'};

  ${({ $isLeftOver }) =>
    $isLeftOver &&
    `
      border-left: 2px solid var(--primary-color);
    `};
  ${({ $isRightOver }) =>
    $isRightOver &&
    `
      border-right: 2px solid var(--primary-color);
    `};
  width: ${props => `${props.$width}px`};
`;
